import { render, staticRenderFns } from "./Lists.vue?vue&type=template&id=0b1d2a84"
import script from "./Lists.vue?vue&type=script&lang=js"
export * from "./Lists.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Lists.vue?vue&type=style&index=1&id=0b1d2a84&prod&lang=css"
import style2 from "./Lists.vue?vue&type=style&index=2&id=0b1d2a84&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports